export const LOG_IN = 'LOGIN'
export const LOG_OUT = 'LOGOUT'
export const SET_USER = 'SET_USER'
export const SET_LOADING = 'SET_LOADING'
export const COMPLETED_DATA = 'COMPLETED_DATA'
export const INTERRUPT_TENNIS = 'INTERRUPT_TENNIS'
export const INTERRUPT_X10 = 'INTERRUPT_X10'
export const INTERRUPT_SAISON = 'INTERRUPT_SAISON'
export const INTERRUPT_RENOUVELLEMENT_SAISON = 'INTERRUPT_RENOUVELLEMENT_SAISON'
export const INTERRUPT_RENDEZ_VOUS = 'INTERRUPT_RENDEZ_VOUS'
export const SET_SOCIAL_NETWORKS = 'SET_SOCIAL_NETWORKS'
